// extracted by mini-css-extract-plugin
export default {"medicalDocuments":"medicalDocuments_medicalDocuments__AeIvU","cardContent":"medicalDocuments_cardContent__QHXYI","secondaryCta":"medicalDocuments_secondaryCta__2x-8b"};